import React, { forwardRef } from 'react';
import { Box, Typography, Button } from '@mui/material';

const SEARCH_ICON_URL =
  'https://assets.askhippo.co.za/Icons/ProviderTiles/Medical-Search-Diagnosis.svg';

const ProviderTileComponentCarousel = forwardRef(
  ({ data, onClick, isMobile, reserveBannerSpace = false }, ref) => {
    const {
      FriendlyName,
      TotalPremium,
      DisplayAmount,
      DisplayAmountCaption = 'From',
      DisplayAmountPrefix = 'R',
      DisplayAmountSuffix = 'pm',
      productCategory,
    } = data;
    const amountValue = Number(DisplayAmount ?? TotalPremium);
    const hasAmount = Number.isFinite(amountValue);
    const amountText = hasAmount
      ? `${DisplayAmountPrefix}${Math.round(amountValue).toLocaleString(
          'en-ZA'
        )}`
      : 'View';

    return (
      <Box
        ref={ref}
        sx={{
          width: isMobile ? '317px' : '389px',
          height: '201px',
          borderRadius: '22px',
          backgroundColor: '#FFFFFF',
          boxShadow: '0px 5px 15px 0px #00000026',
          border: data.bestDeal ? '2px solid #2DC8CB' : 'none',
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start',
          padding: '0 16px 0 290px',
          overflow: 'hidden',
          transition: 'height 0.3s ease',
        }}
      >
        {data.bestDeal && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              backgroundColor: '#2DC8CB',
              borderTopLeftRadius: '18px',
              borderTopRightRadius: '18px',
              alignItems: 'center',
              paddingRight: '24px',
              boxSizing: 'border-box',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: '1.250rem',
                lineHeight: '24px',
                letterSpacing: '-0.03em',
                color: '#FFFFFF',
                textAlign: 'center',
                mt: '4px',
                mb: '4px',
              }}
            >
              Your Best Deal!
            </Typography>
          </Box>
        )}

        {!data.bestDeal &&
          Array.isArray(data.RetailChips) &&
          data.RetailChips.map((chip, idx) => (
            <Box
              key={idx}
              sx={{
                right: '16px',
                top: '16px',
                position: 'absolute',
                fontSize: '0.75rem',
                fontWeight: 600,
                color: '#162F3B',
                backgroundColor: chip.color,
                letterSpacing: '-0.02em',
                lineHeight: '1.125rem', // 18px
                borderRadius: '6px',
                px: '8px',
                py: '2px',
                display: 'inline-block',
                mb: '1px',
              }}
            >
              {chip.text}
            </Box>
          ))}

        {/* Content Section */}
        <Box
          sx={{
            position: 'absolute',
            top: data.bestDeal || reserveBannerSpace ? '44px' : '20px',
            left: '16px',
          }}
        >
          {productCategory && (
            <Typography
              sx={{
                fontFamily: 'Inter',
                fontWeight: 600,
                fontSize: '0.875rem',
                lineHeight: '20px',
                letterSpacing: '-0.02em',
                color: '#6B8594',
                mb: '2px',
              }}
            >
              {productCategory}
            </Typography>
          )}
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 700,
              fontSize: '1.25rem', // 20px
              lineHeight: '24px',
              letterSpacing: '-0.02em',
              color: '#1E354E',
              mb: '4px',
            }}
          >
            {FriendlyName}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: '1rem', // 20px
              lineHeight: '24px',
              letterSpacing: '-0.02em',
              color: '#1E354E',
              mb: '8px',
            }}
          >
            {data.CoverType}
          </Typography>
        </Box>

        {/* Divider Name and Premium */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '92px',
            left: '16px',
            right: '16px',
            height: '1px',
            backgroundColor: '#E0E0E0',
          }}
        />

        {/* Premium Section */}
        <Box
          sx={{
            position: 'absolute',
            left: '16px',
            bottom: '12px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {/* "From" + Premium Group */}
          <Box>
            <Typography
              sx={{
                fontSize: '1rem',
                fontWeight: 400,
                color: '#A2ACB1',
                mb: '-5px',
                ml: '2px',
              }}
            >
              {hasAmount ? DisplayAmountCaption : 'Quote'}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
              <Typography
                sx={{
                  fontFamily: 'Inter',
                  fontWeight: 700,
                  fontSize: '3rem',
                  lineHeight: '120%',
                  letterSpacing: '-0.02em',
                  color: '#1E354E',
                }}
              >
                {amountText}
              </Typography>
              {hasAmount && DisplayAmountSuffix && (
                <Typography
                  sx={{
                    fontSize: '1.25rem',
                    fontWeight: 700,
                    ml: '2px',
                    color: '#1E354E',
                  }}
                >
                  {DisplayAmountSuffix}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>

        <Button
          onClick={onClick}
          sx={{
            position: 'absolute',
            right: '16px',
            bottom: '16px',
            backgroundColor: '#FF0074',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 0,
            padding: '12px',
          }}
        >
          <Box
            component="span"
            sx={{ display: 'inline-flex', alignItems: 'center' }}
          >
            <Box
              component="img"
              src={SEARCH_ICON_URL}
              alt="Search"
              sx={{ width: 18, height: 18, m: 0.5 }}
            />
          </Box>
        </Button>
      </Box>
    );
  }
);
ProviderTileComponentCarousel.displayName = 'ProviderTileComponentCarousel';
export default ProviderTileComponentCarousel;
